import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const LINKS = [{
  label: 'Nosotros',
  href: '#quienes-somos'
}, {
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Clientes',
  href: '#clientes'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-all duration-300 ${scrolled ? 'border-white/15 bg-vm-bg/95 backdrop-blur-md' : 'border-transparent bg-transparent'}`} data-id="element-139" data-mp="ek763eiuuksw">
      <nav className="mx-auto flex h-24 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-140" data-mp="1pwq6axaycu15">
        <a href="#top" aria-label="Vivo Media — Inicio" className="flex h-20 w-[260px] shrink-0 items-center overflow-hidden sm:h-24 sm:w-[340px]" data-id="element-141" data-mp="1kz85xvb03n4r">
          <img src="https://cdn.magicpatterns.com/uploads/mzH2PN3mqF9aVPxsFuUwSS/logo_png_blanco.png" alt="Vivo Media — Tecnología visual en movimiento" className="h-full w-full origin-left scale-[2] object-contain object-left" data-id="element-142" data-mp="em9faos7zlzx" />
        </a>

        <ul className="hidden items-center gap-8 md:flex" data-id="element-143" data-mp="3n4fb190xctqc">
          {LINKS.map(link => <li key={link.href} data-id="element-144" data-mp="3s3icykllyju3">
              <a href={link.href} className="text-sm font-medium uppercase tracking-[0.08em] text-white transition-colors hover:text-vm-muted" data-id="element-145" data-mp="3s2ql9kv4t693">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href="#contacto" className="hidden items-center rounded-2xl bg-vm-sky px-5 py-2 text-sm font-semibold uppercase tracking-[0.1em] text-vm-bg transition-colors hover:bg-vm-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-sky focus-visible:ring-offset-4 focus-visible:ring-offset-vm-bg md:inline-flex" data-id="element-146" data-mp="34d4iyojgqawv">
          Contactar
        </a>

        <button type="button" onClick={() => setOpen(v => !v)} className="p-2 text-white md:hidden" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} data-id="element-147" data-mp="3b133baqyx332">
          {open ? <XIcon className="h-6 w-6" data-id="element-148" data-mp="2idgp78k46g1y" /> : <MenuIcon className="h-6 w-6" data-id="element-149" data-mp="2icnpgrjkoqtb" />}
        </button>
      </nav>

      {open && <div className="border-t border-white/15 bg-vm-bg md:hidden" data-id="element-150" data-mp="2df5gj15k2blb">
          <ul className="space-y-4 px-6 py-6" data-id="element-151" data-mp="2sbmqbny3ji5r">
            {LINKS.map(link => <li key={link.href} data-id="element-152" data-mp="2nayyx15ygzb0">
                <a href={link.href} onClick={() => setOpen(false)} className="block text-sm font-medium uppercase tracking-[0.1em] text-white transition-colors hover:text-vm-muted" data-id="element-153" data-mp="2n9xfo9esd6i7">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>}
    </header>;
}